import { styled } from 'styled-components'

const fixedStyles = (props) =>
  props.fixed
    ? `
vertical-align: top;
display: inline-block;
width: ${props.width};
height: ${props.height};
`
    : undefined

export const IconWrapper = styled.span`
  line-height: 0;
  ${fixedStyles}
`

export const Svg = styled.svg`
  ${(props) => props.rotation && `transform: rotate(${props.rotation}deg);`}
  ${fixedStyles}
`
